export default __webpack_public_path__ + "static/media/bahartitle.cf7ddc52.png";